// import { FieldType } from "../components/Formulario";
import api from "./api";

const controller = "acoes";

export const getAllAcoes = () => api.get<any>(`api/${controller}`);
